export const CHART_KEY_STORE_OVERVIEW_REVENUE_OVER_TIME =
  "store_overview_revenue_over_time";
export const CHART_KEY_STORE_OVERVIEW_TOP_PRODUCTS =
  "store_overview_top_products";
export const CHART_KEY_STORE_OVERVIEW_TOTAL_REVENUE =
  "store_overview_total_revenue";
export const CHART_KEY_STORE_OVERVIEW_ORDERS = "store_overview_orders";
export const CHART_KEY_STORE_OVERVIEW_ITEMS_SOLD = "store_overview_items_sold";
export const CHART_KEY_STORE_OVERVIEW_AVERAGE_ORDER_VALUE =
  "store_overview_average_order_value";
export const CHART_KEY_STORE_OVERVIEW_CUSTOMERS = "store_overview_customers";
export const CHART_KEY_STORE_OVERVIEW_REPEAT_CUSTOMER_RATE =
  "store_overview_repeat_customer_rate";

export const CHART_KEY_STORE_PRODUCT_PERFORMANCE_TOTAL_ORDERS =
  "store_product_performance_total_orders";
export const CHART_KEY_STORE_PRODUCT_PERFORMANCE_TOTAL_ITEMS_SOLD =
  "store_product_performance_total_items_sold";
export const CHART_KEY_STORE_PRODUCT_PERFORMANCE_TOTAL_REVENUE =
  "store_product_performance_total_revenue";
export const CHART_KEY_STORE_PRODUCT_PERFORMANCE_AVG_MARGIN =
  "store_product_performance_avg_margin";

export const CHART_KEY_STORE_CUSTOMER_RETENTION_REPEAT_CUSTOMER_RATE =
  "store_customer_retention_repeat_customer_rate";
export const CHART_KEY_STORE_CUSTOMER_RETENTION_TIME_TO_SECOND_ORDER =
  "store_customer_retention_time_to_second_order";
export const CHART_KEY_STORE_CUSTOMER_RETENTION_AVG_ORDERS_REPEAT_CUSTOMERS =
  "store_customer_retention_avg_orders_repeat_customers";
export const CHART_KEY_STORE_CUSTOMER_RETENTION_REPEAT_PURCHASE_RATE =
  "store_customer_retention_repeat_purchase_rate";

export const CHART_KEY_ECOM_INSIGHTS_TOTAL_REVENUE =
  "ecom_insights_total_revenue";
export const CHART_KEY_ECOM_INSIGHTS_OVERALL_CONTRIBUTION_MARGIN =
  "ecom_insights_overall_contribution_margin";
export const CHART_KEY_ECOM_INSIGHTS_HISTORICAL_CONTRIBUTION_MARGIN =
  "ecom_insights_historical_contribution_margin";
export const CHART_KEY_ECOM_INSIGHTS_MARKETING_EFFICIENCY =
  "ecom_insights_marketing_efficiency";
export const CHART_KEY_ECOM_INSIGHTS_CHANNEL_REVENUE =
  "ecom_insights_channel_revenue";
export const CHART_KEY_ECOM_INSIGHTS_LTV_VS_CAC = "ecom_insights_ltv_vs_cac";
export const CHART_KEY_ECOM_INSIGHTS_TOTAL_SALES_BY_CHANNEL =
  "ecom_insights_total_sales_by_channel";
export const CHART_KEY_ECOM_INSIGHTS_TOTAL_NEW_CUSTOMERS_BY_CHANNEL =
  "ecom_insights_total_new_customers_by_channel";
export const CHART_KEY_ECOM_INSIGHTS_TOTAL_REPEAT_CUSTOMERS_BY_CHANNEL =
  "ecom_insights_total_repeat_customers_by_channel";

// Ecom Insights — Overview stat cards
export const CHART_KEY_ECOM_INSIGHTS_OVERVIEW_STAT_TOTAL_REVENUE =
  "ecom_insights_overview_stat_total_revenue";
export const CHART_KEY_ECOM_INSIGHTS_OVERVIEW_STAT_OVERALL_CONTRIBUTION_MARGIN =
  "ecom_insights_overview_stat_overall_contribution_margin";
export const CHART_KEY_ECOM_INSIGHTS_OVERVIEW_STAT_OVERALL_ROI =
  "ecom_insights_overview_stat_overall_roi";
export const CHART_KEY_ECOM_INSIGHTS_OVERVIEW_STAT_OVERALL_MER =
  "ecom_insights_overview_stat_overall_mer";
export const CHART_KEY_ECOM_INSIGHTS_OVERVIEW_STAT_LTV_CAC_RATIO =
  "ecom_insights_overview_stat_ltv_cac_ratio";
export const CHART_KEY_ECOM_INSIGHTS_OVERVIEW_STAT_NET_REVENUE =
  "ecom_insights_overview_stat_net_revenue";
export const CHART_KEY_ECOM_INSIGHTS_OVERVIEW_STAT_NEW_CUSTOMER_CAC =
  "ecom_insights_overview_stat_new_customer_cac";

// Ecom Insights — New Customers stat cards
export const CHART_KEY_ECOM_INSIGHTS_NEW_CUSTOMERS_STAT_TOTAL_NEW_CUSTOMERS =
  "ecom_insights_new_customers_stat_total_new_customers";
export const CHART_KEY_ECOM_INSIGHTS_NEW_CUSTOMERS_STAT_NEW_CUSTOMER_CAC =
  "ecom_insights_new_customers_stat_new_customer_cac";
export const CHART_KEY_ECOM_INSIGHTS_NEW_CUSTOMERS_STAT_CUSTOMER_CONVERSION_RATE =
  "ecom_insights_new_customers_stat_customer_conversion_rate";

// Ecom Insights — Returning Customers stat cards
export const CHART_KEY_ECOM_INSIGHTS_RETURNING_STAT_REPEAT_CUSTOMERS_COUNT =
  "ecom_insights_returning_stat_repeat_customers_count";
export const CHART_KEY_ECOM_INSIGHTS_RETURNING_STAT_REPEAT_CUSTOMER_RATE =
  "ecom_insights_returning_stat_repeat_customer_rate";
export const CHART_KEY_ECOM_INSIGHTS_RETURNING_STAT_REPEAT_CUSTOMERS_REVENUE =
  "ecom_insights_returning_stat_repeat_customers_revenue";
export const CHART_KEY_ECOM_INSIGHTS_RETURNING_STAT_TOTAL_RETURNING_VISITS =
  "ecom_insights_returning_stat_total_returning_visits";
export const CHART_KEY_ECOM_INSIGHTS_RETURNING_STAT_RETURNING_CUSTOMER_RATE =
  "ecom_insights_returning_stat_returning_customer_rate";
export const CHART_KEY_ECOM_INSIGHTS_RETURNING_STAT_RETURNING_CUSTOMER_CONVERSION_RATE =
  "ecom_insights_returning_stat_returning_customer_conversion_rate";

// New Customers tab
export const CHART_KEY_ECOM_INSIGHTS_NEW_CUSTOMER_REVENUE =
  "ecom_insights_new_customer_revenue";
export const CHART_KEY_ECOM_INSIGHTS_NEW_CUSTOMERS_TREND =
  "ecom_insights_new_customers_trend";
export const CHART_KEY_ECOM_INSIGHTS_VISITS_TO_CONVERSION =
  "ecom_insights_visits_to_conversion";
export const CHART_KEY_ECOM_INSIGHTS_DAYS_TO_CONVERSION =
  "ecom_insights_days_to_conversion";
export const CHART_KEY_ECOM_INSIGHTS_NEW_CUSTOMERS_BY_CHANNEL_PIE =
  "ecom_insights_new_customers_by_channel_pie";
export const CHART_KEY_ECOM_INSIGHTS_NEW_CUSTOMERS_BY_PRODUCT =
  "ecom_insights_new_customers_by_product";

// Returning Customers tab
export const CHART_KEY_ECOM_INSIGHTS_REPEAT_CUSTOMER_REVENUE =
  "ecom_insights_repeat_customer_revenue";
export const CHART_KEY_ECOM_INSIGHTS_RETURNING_VISITS_TREND =
  "ecom_insights_returning_visits_trend";
export const CHART_KEY_ECOM_INSIGHTS_VISITS_BETWEEN_CONVERSIONS =
  "ecom_insights_visits_between_conversions";
export const CHART_KEY_ECOM_INSIGHTS_DAYS_BETWEEN_CONVERSIONS =
  "ecom_insights_days_between_conversions";
export const CHART_KEY_ECOM_INSIGHTS_RETURNING_CUSTOMERS_BY_CHANNEL_PIE =
  "ecom_insights_returning_customers_by_channel_pie";
export const CHART_KEY_ECOM_INSIGHTS_RETURNING_CUSTOMERS_PRODUCT_INTERACTION =
  "ecom_insights_returning_customers_product_interaction";

// Products tab
export const CHART_KEY_ECOM_INSIGHTS_TOP_PRODUCTS_BY_METRIC =
  "ecom_insights_top_products_by_metric";
export const CHART_KEY_ECOM_INSIGHTS_PRODUCT_INSIGHTS_TABLE =
  "ecom_insights_product_insights_table";
export const CHART_KEY_ECOM_INSIGHTS_PRODUCT_CATEGORY_INSIGHTS =
  "ecom_insights_product_category_insights";
export const CHART_KEY_ECOM_INSIGHTS_PRODUCT_BRAND_STATS =
  "ecom_insights_product_brand_stats";

// Campaigns tab
export const CHART_KEY_ECOM_INSIGHTS_PAID_CAMPAIGNS_TABLE =
  "ecom_insights_paid_campaigns_table";
export const CHART_KEY_ECOM_INSIGHTS_PAID_CAMPAIGNS_LANDING_PAGES_TABLE =
  "ecom_insights_paid_campaigns_landing_pages_table";

// Site Overview (Quick Insights)
export const CHART_KEY_SITE_OVERVIEW_TRAFFIC_TREND =
  "site_overview_traffic_trend";
export const CHART_KEY_SITE_OVERVIEW_ENGAGEMENT_TREND =
  "site_overview_engagement_trend";
export const CHART_KEY_SITE_OVERVIEW_CONVERSION_TREND =
  "site_overview_conversion_trend";
export const CHART_KEY_SITE_OVERVIEW_CHANNEL_PERFORMANCE_PIE =
  "site_overview_channel_performance_pie";
export const CHART_KEY_SITE_OVERVIEW_TOP_CHANNELS =
  "site_overview_top_channels";
export const CHART_KEY_SITE_OVERVIEW_METRICS_BY_TYPE =
  "site_overview_metrics_by_type";
export const CHART_KEY_SITE_OVERVIEW_VISITORS_BY_TYPE_PIE =
  "site_overview_visitors_by_type_pie";
export const CHART_KEY_SITE_OVERVIEW_STAT_TRAFFIC =
  "site_overview_stat_traffic";
export const CHART_KEY_SITE_OVERVIEW_STAT_ENGAGEMENT =
  "site_overview_stat_engagement";
export const CHART_KEY_SITE_OVERVIEW_STAT_CONVERSION =
  "site_overview_stat_conversion";

// Channel Insights (Quick Insights)
export const CHART_KEY_CHANNEL_INSIGHTS_TRAFFIC_PERFORMANCE_TABLE =
  "channel_insights_traffic_performance_table";

// Content Insights (Quick Insights)
export const CHART_KEY_CONTENT_INSIGHTS_TOP_LANDING_TREND =
  "content_insights_top_landing_trend";
export const CHART_KEY_CONTENT_INSIGHTS_TOP_LANDING_PIE =
  "content_insights_top_landing_pie";
export const CHART_KEY_CONTENT_INSIGHTS_LANDING_TABLE =
  "content_insights_landing_table";

// Device Insights (Quick Insights)
export const CHART_KEY_DEVICE_INSIGHTS_COMPOSITION_PIE =
  "device_insights_composition_pie";
export const CHART_KEY_DEVICE_INSIGHTS_TYPE_TREND =
  "device_insights_type_trend";
export const CHART_KEY_DEVICE_INSIGHTS_DEVICE_TABLE =
  "device_insights_device_table";
export const CHART_KEY_DEVICE_INSIGHTS_BROWSER_TABLE =
  "device_insights_browser_table";

// Email Marketing Overview
export const CHART_KEY_EMAIL_TOP_BY_TREND = "email_top_by_trend";
export const CHART_KEY_EMAIL_PERFORMANCE_COMPOSITION =
  "email_performance_composition";
export const CHART_KEY_EMAIL_SESSIONS_BY_AUDIENCE =
  "email_sessions_by_audience";
export const CHART_KEY_EMAIL_SESSIONS_REVENUE_BY_CAMPAIGN =
  "email_sessions_revenue_by_campaign";
export const CHART_KEY_EMAIL_CAMPAIGNS_TABLE = "email_campaigns_table";

// Organic Social Overview
export const CHART_KEY_ORGANIC_SOCIAL_TOP_SESSIONS_BY_LANDING =
  "organic_social_top_sessions_by_landing";
export const CHART_KEY_ORGANIC_SOCIAL_SESSIONS_COMPOSITION_BY_LANDING =
  "organic_social_sessions_composition_by_landing";
export const CHART_KEY_ORGANIC_SOCIAL_LANDING_PRIMARY_METRICS =
  "organic_social_landing_primary_metrics";
export const CHART_KEY_ORGANIC_SOCIAL_PLATFORMS_PRIMARY_METRICS =
  "organic_social_platforms_primary_metrics";
export const CHART_KEY_ORGANIC_SOCIAL_TOP_AUDIENCES =
  "organic_social_top_audiences";
export const CHART_KEY_ORGANIC_SOCIAL_BEST_DAYS = "organic_social_best_days";
export const CHART_KEY_ORGANIC_SOCIAL_TOP_PATHS = "organic_social_top_paths";

// Locations Overview
export const CHART_KEY_LOCATIONS_TOP_TRAFFIC_SOURCES_PAGEVIEWS =
  "locations_top_traffic_sources_pageviews";
export const CHART_KEY_LOCATIONS_TOP_TRAFFIC_SOURCES_LANDING =
  "locations_top_traffic_sources_landing";
export const CHART_KEY_LOCATIONS_AUDIENCE_COMPOSITION =
  "locations_audience_composition";
export const CHART_KEY_LOCATIONS_PAGEVIEWS_ENGAGEMENT_TREND =
  "locations_pageviews_engagement_trend";
export const CHART_KEY_LOCATIONS_PAGES_TABLE = "locations_pages_table";
export const CHART_KEY_LOCATIONS_LANDING_PAGE_TABLE =
  "locations_landing_page_table";

// Products Overview
export const CHART_KEY_PRODUCTS_OVERVIEW_CATEGORY_BRAND_INSIGHTS =
  "products_overview_category_brand_insights";
export const CHART_KEY_PRODUCTS_OVERVIEW_PRODUCT_INSIGHTS =
  "products_overview_product_insights";

// Audience New & Returning
export const CHART_KEY_AUDIENCE_NEW_RETURNING_SESSIONS_BY_CHANNELS =
  "audience_new_returning_sessions_by_channels";
export const CHART_KEY_AUDIENCE_NEW_RETURNING_SESSIONS_BY_CHANNELS_COMPOSITION =
  "audience_new_returning_sessions_by_channels_composition";
export const CHART_KEY_AUDIENCE_NEW_RETURNING_TOP_LANDING_PAGES =
  "audience_new_returning_top_landing_pages";
export const CHART_KEY_AUDIENCE_NEW_RETURNING_TOP_SECOND_PAGEVIEWS =
  "audience_new_returning_top_second_pageviews";
export const CHART_KEY_AUDIENCE_NEW_RETURNING_TOP_MARKETING_CHANNELS =
  "audience_new_returning_top_marketing_channels";
export const CHART_KEY_AUDIENCE_NEW_RETURNING_EFFECTIVE_SESSION_TREND =
  "audience_new_returning_effective_session_trend";
export const CHART_KEY_AUDIENCE_NEW_RETURNING_AVG_TIME_ON_PAGE_TREND =
  "audience_new_returning_avg_time_on_page_trend";
export const CHART_KEY_AUDIENCE_NEW_RETURNING_SESSION_CONVERSIONS =
  "audience_new_returning_session_conversions";

// Audience User Journey
export const CHART_KEY_AUDIENCE_USER_JOURNEY_AUDIENCE_COMPOSITION =
  "audience_user_journey_audience_composition";
export const CHART_KEY_AUDIENCE_USER_JOURNEY_TOP_DIMENSION_TREND =
  "audience_user_journey_top_dimension_trend";
export const CHART_KEY_AUDIENCE_USER_JOURNEY_CONVERSION_JOURNEY_CHANNEL =
  "audience_user_journey_conversion_journey_channel";
export const CHART_KEY_AUDIENCE_USER_JOURNEY_CONVERSION_JOURNEY_PAGEVIEW =
  "audience_user_journey_conversion_journey_pageview";
export const CHART_KEY_AUDIENCE_USER_JOURNEY_SESSIONS_PRIOR_CONVERSIONS =
  "audience_user_journey_sessions_prior_conversions";
export const CHART_KEY_AUDIENCE_USER_JOURNEY_DAYS_PRIOR_CONVERSIONS =
  "audience_user_journey_days_prior_conversions";

// Audience Deep Dive
export const CHART_KEY_AUDIENCE_DEEP_DIVE_TOP_CHANNELS_RADAR =
  "audience_deep_dive_top_channels_radar";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_CHANNEL_INSIGHTS =
  "audience_deep_dive_channel_insights";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_PRODUCT_CATEGORY_INSIGHTS =
  "audience_deep_dive_product_category_insights";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_TOP_PRODUCT_CATEGORY_RADAR =
  "audience_deep_dive_top_product_category_radar";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_AUDIENCE_PRIMARY_METRICS =
  "audience_deep_dive_audience_primary_metrics";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_SESSIONS_AND_PAGEVIEWS =
  "audience_deep_dive_sessions_and_pageviews";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_AVG_TIME_ON_PAGE =
  "audience_deep_dive_avg_time_on_page";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_EFFECTIVE_SESSIONS_AND_PAGEVIEWS =
  "audience_deep_dive_effective_sessions_and_pageviews";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_INTERACTIONS_AND_CONVERSIONS =
  "audience_deep_dive_interactions_and_conversions";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_PRODUCT_PRIMARY_METRICS =
  "audience_deep_dive_product_primary_metrics";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_LANDING_PAGE_PRIMARY_METRICS =
  "audience_deep_dive_landing_page_primary_metrics";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_CHANNEL_PRIMARY_METRICS =
  "audience_deep_dive_channel_primary_metrics";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_VISITS_PRIOR_CONVERSION_BY_CHANNEL =
  "audience_deep_dive_visits_prior_conversion_by_channel";
export const CHART_KEY_AUDIENCE_DEEP_DIVE_CHANNEL_ROI_LTV_METRICS =
  "audience_deep_dive_channel_roi_ltv_metrics";

// Audience Comparison — Overview
export const CHART_KEY_AUDIENCE_COMPARISON_OVERVIEW_CHANNEL_PERFORMANCE =
  "audience_comparison_overview_channel_performance";
export const CHART_KEY_AUDIENCE_COMPARISON_OVERVIEW_SESSION_COMPARISONS =
  "audience_comparison_overview_session_comparisons";
export const CHART_KEY_AUDIENCE_COMPARISON_OVERVIEW_AVG_CONVERSIONS_VS_INTERACTIONS =
  "audience_comparison_overview_avg_conversions_vs_interactions";
export const CHART_KEY_AUDIENCE_COMPARISON_OVERVIEW_CONVERSION_COMPARISONS =
  "audience_comparison_overview_conversion_comparisons";
export const CHART_KEY_AUDIENCE_COMPARISON_OVERVIEW_COMPOSITION =
  "audience_comparison_overview_composition";
export const CHART_KEY_AUDIENCE_COMPARISON_OVERVIEW_SESSION_ENGAGEMENT_LEVELS =
  "audience_comparison_overview_session_engagement_levels";
export const CHART_KEY_AUDIENCE_COMPARISON_OVERVIEW_PRIMARY_STATS_BY_CHANNEL =
  "audience_comparison_overview_primary_stats_by_channel";
export const CHART_KEY_AUDIENCE_COMPARISON_OVERVIEW_PRIMARY_STATS_BY_CHANNEL_TABLE =
  "audience_comparison_overview_primary_stats_by_channel_table";
export const CHART_KEY_AUDIENCE_COMPARISON_OVERVIEW_ROAS_LTV_BY_CHANNEL =
  "audience_comparison_overview_roas_ltv_by_channel";
export const CHART_KEY_AUDIENCE_COMPARISON_OVERVIEW_SESSIONS_BY_VISITOR_TYPE =
  "audience_comparison_overview_sessions_by_visitor_type";
export const CHART_KEY_AUDIENCE_COMPARISON_OVERVIEW_CONVERSIONS_BY_VISITOR_TYPE =
  "audience_comparison_overview_conversions_by_visitor_type";

// Audience Comparison — Engagement
export const CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_PERFORMANCE_BUBBLE =
  "audience_comparison_engagement_performance_bubble";
export const CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_PRIMARY_STATS =
  "audience_comparison_engagement_primary_stats";
export const CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_VISITOR_TYPE =
  "audience_comparison_engagement_effective_sessions_by_visitor_type";
export const CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_VISITOR_TYPE_PIE =
  "audience_comparison_engagement_effective_sessions_by_visitor_type_pie";
export const CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_DEVICE =
  "audience_comparison_engagement_effective_sessions_by_device";
export const CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_DEVICE_PIE =
  "audience_comparison_engagement_effective_sessions_by_device_pie";

// Audience Comparison — Geographic
export const CHART_KEY_AUDIENCE_COMPARISON_GEO_SESSIONS_BY_COUNTRIES_MAP =
  "audience_comparison_geo_sessions_by_countries_map";
export const CHART_KEY_AUDIENCE_COMPARISON_GEO_COUNTRY_PRIMARY_STATS =
  "audience_comparison_geo_country_primary_stats";
export const CHART_KEY_AUDIENCE_COMPARISON_GEO_TOP_COUNTRIES_BY_SESSIONS =
  "audience_comparison_geo_top_countries_by_sessions";
export const CHART_KEY_AUDIENCE_COMPARISON_GEO_TOP_COUNTRIES_BY_CONVERSIONS =
  "audience_comparison_geo_top_countries_by_conversions";
export const CHART_KEY_AUDIENCE_COMPARISON_GEO_REGION_PRIMARY_STATS =
  "audience_comparison_geo_region_primary_stats";
export const CHART_KEY_AUDIENCE_COMPARISON_GEO_TOP_REGIONS_BY_SESSIONS =
  "audience_comparison_geo_top_regions_by_sessions";
export const CHART_KEY_AUDIENCE_COMPARISON_GEO_TOP_REGIONS_BY_CONVERSIONS =
  "audience_comparison_geo_top_regions_by_conversions";
export const CHART_KEY_AUDIENCE_COMPARISON_GEO_CITY_PRIMARY_STATS =
  "audience_comparison_geo_city_primary_stats";
export const CHART_KEY_AUDIENCE_COMPARISON_GEO_TOP_CITIES_BY_SESSIONS =
  "audience_comparison_geo_top_cities_by_sessions";
export const CHART_KEY_AUDIENCE_COMPARISON_GEO_TOP_CITIES_BY_CONVERSIONS =
  "audience_comparison_geo_top_cities_by_conversions";

// Audience Comparison — New vs Returning
export const CHART_KEY_AUDIENCE_COMPARISON_NEW_RETURNING_PRIMARY_METRICS =
  "audience_comparison_new_returning_primary_metrics";
export const CHART_KEY_AUDIENCE_COMPARISON_NEW_RETURNING_SESSIONS_CONVERSIONS =
  "audience_comparison_new_returning_sessions_conversions";
export const CHART_KEY_AUDIENCE_COMPARISON_NEW_RETURNING_SESSIONS_TREND =
  "audience_comparison_new_returning_sessions_trend";
export const CHART_KEY_AUDIENCE_COMPARISON_NEW_RETURNING_EFFECTIVE_RATE_TREND =
  "audience_comparison_new_returning_effective_rate_trend";
export const CHART_KEY_AUDIENCE_COMPARISON_NEW_RETURNING_TIME_SPENT_TREND =
  "audience_comparison_new_returning_time_spent_trend";
export const CHART_KEY_AUDIENCE_COMPARISON_NEW_RETURNING_CONVERSIONS_TREND =
  "audience_comparison_new_returning_conversions_trend";
export const CHART_KEY_AUDIENCE_COMPARISON_NEW_RETURNING_TOP_INTERACTIONS =
  "audience_comparison_new_returning_top_interactions";

// Audience Comparison — Device & Browsers
export const CHART_KEY_AUDIENCE_COMPARISON_DEVICE_PRIMARY_METRICS =
  "audience_comparison_device_primary_metrics";
export const CHART_KEY_AUDIENCE_COMPARISON_DEVICE_SESSIONS_CONVERSIONS =
  "audience_comparison_device_sessions_conversions";
export const CHART_KEY_AUDIENCE_COMPARISON_DEVICE_SESSIONS_TREND =
  "audience_comparison_device_sessions_trend";
export const CHART_KEY_AUDIENCE_COMPARISON_DEVICE_EFFECTIVE_RATE_TREND =
  "audience_comparison_device_effective_rate_trend";
export const CHART_KEY_AUDIENCE_COMPARISON_DEVICE_TIME_SPENT_TREND =
  "audience_comparison_device_time_spent_trend";
export const CHART_KEY_AUDIENCE_COMPARISON_DEVICE_CONVERSIONS_TREND =
  "audience_comparison_device_conversions_trend";
export const CHART_KEY_AUDIENCE_COMPARISON_DEVICE_TOP_INTERACTIONS =
  "audience_comparison_device_top_interactions";
export const CHART_KEY_AUDIENCE_COMPARISON_DEVICE_BROWSERS_PRIMARY_METRICS =
  "audience_comparison_device_browsers_primary_metrics";
export const CHART_KEY_AUDIENCE_COMPARISON_DEVICE_TOP_BROWSERS =
  "audience_comparison_device_top_browsers";

// Audience Comparison — Traffic & Conversions
export const CHART_KEY_AUDIENCE_COMPARISON_TRAFFIC_SESSION_ENGAGEMENT_BY_LOCATION =
  "audience_comparison_traffic_session_engagement_by_location";
export const CHART_KEY_AUDIENCE_COMPARISON_TRAFFIC_PAGE_LOCATIONS_COMPOSITION =
  "audience_comparison_traffic_page_locations_composition";
export const CHART_KEY_AUDIENCE_COMPARISON_TRAFFIC_TOP_INTERACTIONS_BY_LOCATION =
  "audience_comparison_traffic_top_interactions_by_location";
export const CHART_KEY_AUDIENCE_COMPARISON_TRAFFIC_INTERACTION_COMPOSITION =
  "audience_comparison_traffic_interaction_composition";
export const CHART_KEY_AUDIENCE_COMPARISON_TRAFFIC_PAGE_LOCATIONS_INTERACTIONS_STATS =
  "audience_comparison_traffic_page_locations_interactions_stats";
export const CHART_KEY_AUDIENCE_COMPARISON_TRAFFIC_DAY_OF_WEEK_PRIMARY_STATS =
  "audience_comparison_traffic_day_of_week_primary_stats";

// Paid Media — Attribution
export const CHART_KEY_PAID_MEDIA_ATTRIBUTION_SPEND_PIE =
  "paid_media_attribution_spend_pie";
export const CHART_KEY_PAID_MEDIA_ATTRIBUTION_SALES_COUNT =
  "paid_media_attribution_sales_count";
export const CHART_KEY_PAID_MEDIA_ATTRIBUTION_ROI =
  "paid_media_attribution_roi";
export const CHART_KEY_PAID_MEDIA_ATTRIBUTION_SESSIONS_ENGAGEMENT =
  "paid_media_attribution_sessions_engagement";
export const CHART_KEY_PAID_MEDIA_ATTRIBUTION_CONVERSION_LTV =
  "paid_media_attribution_conversion_ltv";
export const CHART_KEY_PAID_MEDIA_ATTRIBUTION_PERFORMANCE_PIE =
  "paid_media_attribution_performance_pie";
export const CHART_KEY_PAID_MEDIA_ATTRIBUTION_REVENUE_TABLE =
  "paid_media_attribution_revenue_table";
export const CHART_KEY_PAID_MEDIA_ATTRIBUTION_CAC =
  "paid_media_attribution_cac";
export const CHART_KEY_PAID_MEDIA_ATTRIBUTION_NEW_CUSTOMER_ACQUISITION =
  "paid_media_attribution_new_customer_acquisition";

// Paid Media — Creatives
export const CHART_KEY_PAID_MEDIA_CREATIVES_PRIMARY_STATS =
  "paid_media_creatives_primary_stats";
export const CHART_KEY_PAID_MEDIA_CREATIVES_PERFORMANCE_BUBBLE =
  "paid_media_creatives_performance_bubble";

// Organic — Overview
export const CHART_KEY_ORGANIC_OVERVIEW_SESSIONS_VS_METRIC =
  "organic_overview_sessions_vs_metric";
export const CHART_KEY_ORGANIC_OVERVIEW_DEVICE_PERFORMANCE =
  "organic_overview_device_performance";

// Organic — Landing Pages
export const CHART_KEY_ORGANIC_LANDING_PAGES_METRICS_TABLE =
  "organic_landing_pages_metrics_table";
export const CHART_KEY_ORGANIC_LANDING_PAGES_SESSIONS_PIE =
  "organic_landing_pages_sessions_pie";
export const CHART_KEY_ORGANIC_LANDING_PAGES_REVENUE_PIE =
  "organic_landing_pages_revenue_pie";

// Organic — Crawler Analysis
export const CHART_KEY_ORGANIC_CRAWLER_TOP_VISITS_TREND =
  "organic_crawler_top_visits_trend";
export const CHART_KEY_ORGANIC_CRAWLER_CRAWLED_PAGES_TABLE =
  "organic_crawler_crawled_pages_table";
export const CHART_KEY_ORGANIC_CRAWLER_TOP_CRAWLERS_PIE =
  "organic_crawler_top_crawlers_pie";
export const CHART_KEY_ORGANIC_CRAWLER_NOT_CRAWLED_PAGES_TABLE =
  "organic_crawler_not_crawled_pages_table";

// Organic — Stock Impact
export const CHART_KEY_ORGANIC_STOCK_IMPACT_TREND =
  "organic_stock_impact_trend";
export const CHART_KEY_ORGANIC_STOCK_IMPACT_PAGES_COMPARISON_TABLE =
  "organic_stock_impact_pages_comparison_table";
export const CHART_KEY_ORGANIC_STOCK_IMPACT_PAGES_TABLE =
  "organic_stock_impact_pages_table";

export const CHART_KEY_ATTRIBUTION_HEADER_TOP_BY_TREND =
  "attribution_header_top_by_trend";

// Dashboard — Pulse
export const CHART_KEY_DASHBOARD_PULSE_TOTAL_REVENUE =
  "dashboard_pulse_total_revenue";
export const CHART_KEY_DASHBOARD_PULSE_OVERALL_CONTRIBUTION_MARGIN =
  "dashboard_pulse_overall_contribution_margin";
export const CHART_KEY_DASHBOARD_PULSE_OVERALL_ROI =
  "dashboard_pulse_overall_roi";
export const CHART_KEY_DASHBOARD_PULSE_OVERALL_MER =
  "dashboard_pulse_overall_mer";

// Dashboard — Pulse (non-ecommerce)
export const CHART_KEY_DASHBOARD_PULSE_ORGANIC_SESSIONS =
  "dashboard_pulse_organic_sessions";
export const CHART_KEY_DASHBOARD_PULSE_PAID_SESSIONS =
  "dashboard_pulse_paid_sessions";
export const CHART_KEY_DASHBOARD_PULSE_EFFECTIVENESS_RATE =
  "dashboard_pulse_effectiveness_rate";
export const CHART_KEY_DASHBOARD_PULSE_CONVERSIONS =
  "dashboard_pulse_conversions";
export const CHART_KEY_DASHBOARD_PULSE_SESSIONS_CONVERSIONS =
  "dashboard_pulse_sessions_conversions";

// Dashboard — Store Overview
export const CHART_KEY_DASHBOARD_STORE_OVERVIEW_ORDERS =
  "dashboard_store_overview_orders";
export const CHART_KEY_DASHBOARD_STORE_OVERVIEW_ITEMS_SOLD =
  "dashboard_store_overview_items_sold";
export const CHART_KEY_DASHBOARD_STORE_OVERVIEW_AOV =
  "dashboard_store_overview_aov";
export const CHART_KEY_DASHBOARD_STORE_OVERVIEW_CUSTOMERS =
  "dashboard_store_overview_customers";

// Dashboard — Profitability
export const CHART_KEY_DASHBOARD_PROFITABILITY_LTV_CAC =
  "dashboard_profitability_ltv_cac";
export const CHART_KEY_DASHBOARD_PROFITABILITY_NET_REVENUE =
  "dashboard_profitability_net_revenue";
export const CHART_KEY_DASHBOARD_PROFITABILITY_CAC =
  "dashboard_profitability_cac";

// Dashboard — New & Returning
export const CHART_KEY_DASHBOARD_NEW_RETURNING_NEW_CUSTOMERS =
  "dashboard_new_returning_new_customers";
export const CHART_KEY_DASHBOARD_NEW_RETURNING_REPEAT_CUSTOMERS =
  "dashboard_new_returning_repeat_customers";
export const CHART_KEY_DASHBOARD_NEW_RETURNING_REPEAT_RATE =
  "dashboard_new_returning_repeat_rate";
export const CHART_KEY_DASHBOARD_NEW_RETURNING_REPEAT_REVENUE =
  "dashboard_new_returning_repeat_revenue";

// Dashboard — Lifetime Value
export const CHART_KEY_DASHBOARD_LTV_LTV_CAC = "dashboard_ltv_ltv_cac";
export const CHART_KEY_DASHBOARD_LTV_CAC = "dashboard_ltv_cac";

// Dashboard — Site Performance
export const CHART_KEY_DASHBOARD_CWV_OVERALL =
  "dashboard_cwv_overall_score";
export const CHART_KEY_DASHBOARD_CWV_BOUNCE_RATE =
  "dashboard_cwv_bounce_rate";
export const CHART_KEY_DASHBOARD_CWV_EXIT_RATE = "dashboard_cwv_exit_rate";
export const CHART_KEY_DASHBOARD_SPEED_LANDING_CWV =
  "dashboard_speed_landing_cwv_stat";
export const CHART_KEY_DASHBOARD_SPEED_LANDING_BOUNCE =
  "dashboard_speed_landing_bounce";
export const CHART_KEY_DASHBOARD_SPEED_LANDING_TIME_ON_PAGE =
  "dashboard_speed_landing_time_on_page";

// Dashboard — Content
export const CHART_KEY_DASHBOARD_PAGES_SESSIONS = "dashboard_pages_sessions";
export const CHART_KEY_DASHBOARD_PAGES_PAGEVIEWS = "dashboard_pages_pageviews";
export const CHART_KEY_DASHBOARD_PAGES_EFFECTIVE_RATE =
  "dashboard_pages_effective_rate";
export const CHART_KEY_DASHBOARD_PAGES_AVG_TIME = "dashboard_pages_avg_time";

// Dashboard — Engagement
export const CHART_KEY_DASHBOARD_SITE_OVERVIEW_TRAFFIC =
  "dashboard_site_overview_traffic";
export const CHART_KEY_DASHBOARD_SITE_OVERVIEW_ENGAGEMENT =
  "dashboard_site_overview_engagement";
export const CHART_KEY_DASHBOARD_SITE_OVERVIEW_CONVERSION =
  "dashboard_site_overview_conversion";

// Dashboard — charts (editable standard cards)
export const CHART_KEY_DASHBOARD_PULSE_FUNNEL = "dashboard_pulse_funnel";
export const CHART_KEY_DASHBOARD_PULSE_SESSIONS_REVENUE =
  "dashboard_pulse_sessions_revenue";
export const CHART_KEY_DASHBOARD_STORE_OVERVIEW_REVENUE_TREND =
  "dashboard_store_overview_revenue_trend";
export const CHART_KEY_DASHBOARD_STORE_OVERVIEW_TOP_PRODUCTS =
  "dashboard_store_overview_top_products";
export const CHART_KEY_DASHBOARD_PROFITABILITY_MARGIN_TREND =
  "dashboard_profitability_margin_trend";
export const CHART_KEY_DASHBOARD_PROFITABILITY_MER_TREND =
  "dashboard_profitability_mer_trend";
export const CHART_KEY_DASHBOARD_MARKETING_TOP_CHANNELS =
  "dashboard_marketing_top_channels";
export const CHART_KEY_DASHBOARD_MARKETING_TRAFFIC_TABLE =
  "dashboard_marketing_traffic_table";
export const CHART_KEY_DASHBOARD_CHANNEL_MIX_PIE = "dashboard_channel_mix_pie";
export const CHART_KEY_DASHBOARD_CHANNEL_MIX_BAR = "dashboard_channel_mix_bar";
export const CHART_KEY_DASHBOARD_CHANNEL_MIX_TABLE =
  "dashboard_channel_mix_table";
export const CHART_KEY_DASHBOARD_EMAIL_CAMPAIGN_TREND =
  "dashboard_email_campaign_trend";
export const CHART_KEY_DASHBOARD_EMAIL_CAMPAIGN_TABLE =
  "dashboard_email_campaign_table";
export const CHART_KEY_DASHBOARD_EMAIL_SESSIONS_STAT =
  "dashboard_email_sessions_stat";
export const CHART_KEY_DASHBOARD_EMAIL_VISIT_PURCHASE_STAT =
  "dashboard_email_visit_purchase_stat";
export const CHART_KEY_DASHBOARD_EMAIL_RETURNING_STAT =
  "dashboard_email_returning_stat";
export const CHART_KEY_DASHBOARD_NEW_RETURNING_REVENUE_TREND =
  "dashboard_new_returning_revenue_trend";
export const CHART_KEY_DASHBOARD_LTV_TREND = "dashboard_ltv_trend";
export const CHART_KEY_DASHBOARD_BESTSELLERS_TREND =
  "dashboard_bestsellers_trend";
export const CHART_KEY_DASHBOARD_BESTSELLERS_TABLE =
  "dashboard_bestsellers_table";
export const CHART_KEY_DASHBOARD_CATEGORIES_TOP =
  "dashboard_categories_top";
export const CHART_KEY_DASHBOARD_CATEGORIES_TABLE =
  "dashboard_categories_table";
export const CHART_KEY_DASHBOARD_BRANDS_TABLE = "dashboard_brands_table";
export const CHART_KEY_DASHBOARD_PAID_MEDIA_TABLE =
  "dashboard_paid_media_table";
export const CHART_KEY_DASHBOARD_ATTRIBUTION_SPEND_PIE =
  "dashboard_attribution_spend_pie";
export const CHART_KEY_DASHBOARD_ATTRIBUTION_SALES_BAR =
  "dashboard_attribution_sales_bar";
export const CHART_KEY_DASHBOARD_ATTRIBUTION_ROI_BAR =
  "dashboard_attribution_roi_bar";
export const CHART_KEY_DASHBOARD_CAMPAIGNS_TABLE =
  "dashboard_campaigns_table";
export const CHART_KEY_DASHBOARD_CWV_PERFORMANCE_BAR =
  "dashboard_cwv_performance_bar";
export const CHART_KEY_DASHBOARD_CWV_TABLE = "dashboard_cwv_table";
export const CHART_KEY_DASHBOARD_SLOW_PAGES_CWV_BAR =
  "dashboard_slow_pages_cwv_bar";
export const CHART_KEY_DASHBOARD_SLOW_PAGES_TRAFFIC_BAR =
  "dashboard_slow_pages_traffic_bar";
export const CHART_KEY_DASHBOARD_SLOW_PAGES_TABLE =
  "dashboard_slow_pages_table";
export const CHART_KEY_DASHBOARD_SPEED_LANDING_CWV_BAR =
  "dashboard_speed_landing_cwv_bar";
export const CHART_KEY_DASHBOARD_SPEED_LANDING_TIME_BAR =
  "dashboard_speed_landing_time_bar";
export const CHART_KEY_DASHBOARD_SPEED_LANDING_TABLE =
  "dashboard_speed_landing_table";
export const CHART_KEY_DASHBOARD_LANDING_TREND =
  "dashboard_landing_pages_trend";
export const CHART_KEY_DASHBOARD_LANDING_PIE = "dashboard_landing_pages_pie";
export const CHART_KEY_DASHBOARD_LANDING_TABLE =
  "dashboard_landing_pages_table";
export const CHART_KEY_DASHBOARD_CONTENT_TOP_BAR =
  "dashboard_content_performance_top_bar";
export const CHART_KEY_DASHBOARD_CONTENT_IMPROVE_BAR =
  "dashboard_content_performance_improve_bar";
export const CHART_KEY_DASHBOARD_CONTENT_TABLE =
  "dashboard_content_performance_table";
export const CHART_KEY_DASHBOARD_PAGES_TREND = "dashboard_pages_trend";
export const CHART_KEY_DASHBOARD_PAGES_TABLE = "dashboard_pages_table";
export const CHART_KEY_DASHBOARD_DEVICES_PIE = "dashboard_devices_pie";
export const CHART_KEY_DASHBOARD_DEVICES_TREND = "dashboard_devices_trend";
export const CHART_KEY_DASHBOARD_DEVICES_TABLE = "dashboard_devices_table";
export const CHART_KEY_DASHBOARD_SITE_OVERVIEW_ENGAGEMENT_TREND =
  "dashboard_site_overview_engagement_trend";
export const CHART_KEY_DASHBOARD_SITE_OVERVIEW_TOP_CHANNELS =
  "dashboard_site_overview_top_channels";
export const CHART_KEY_DASHBOARD_FUNNEL_ECOM = "dashboard_funnel_ecom";
export const CHART_KEY_DASHBOARD_FUNNEL_SALES_FLOW =
  "dashboard_funnel_sales_flow";
